// window.kgHandleVariantChange = function (kgVariant) {
//   const kgNav = document.querySelector("product-gallery-navigation"); // adjust selector if it's .class
//   const kgGalleryCarousel = document.querySelector(".product-gallery__carousel");

//   if (!kgNav) return;

//   // Hide all thumbnails first
//   const kgThumbs = kgNav.querySelectorAll("button.product-gallery__thumbnail");
//   const kgAllCarouselImgs = kgGalleryCarousel.querySelectorAll(".product-gallery__media img");
//   const kgAllCarouselImgWrap = kgGalleryCarousel.querySelectorAll(".product-gallery__media");
//   kgThumbs.forEach(el => el.style.display = "none");
//   kgAllCarouselImgs.forEach(el => el.classList.add("kg-hidden"));
//   kgAllCarouselImgWrap.forEach(el => el.style.display = "none");

//   // Collect all variant options (skip empty ones)
//   const kgOptions = [kgVariant.option1, kgVariant.option2, kgVariant.option3].filter(Boolean);

//   let kgMatches = 0;

//   // Show thumbnails (the <button>) that contain a matching <img>
//   kgOptions.forEach(kgOpt => {
//     const kgImgs = kgNav.querySelectorAll(`img[alt="${kgOpt}"]`);
//     kgImgs.forEach(img => {
//       const parentBtn = img.closest("button.product-gallery__thumbnail");
//       if (parentBtn) {
//         parentBtn.style.display = "block";
//         kgMatches++;
//       }
//     });

//     const kgMatchingCarouselImgs = kgGalleryCarousel.querySelectorAll(`.product-gallery__media img[alt="${kgOpt}"]`);
//     kgMatchingCarouselImgs.forEach(img => {
//       if (img) {
//         const kgParentMedia = img.closest(".product-gallery__media");
//         if (kgParentMedia) {
//           kgParentMedia.style.display = "block"; // show parent
//         }
//         img.classList.remove("kg-hidden");
//       }
//     });
//   });

//   // Fallback: if no matches found, show all thumbnails
//   if (kgMatches === 0) {
//     kgThumbs.forEach(el => el.style.display = "block");
//     kgAllCarouselImgs.forEach(el => el.classList.remove("kg-hidden"));
//     kgAllCarouselImgWrap.forEach(el => el.style.display = "block");
//   }
// };

// window.kgHandleVariantChange = function (kgVariant) {
//   const kgNav = document.querySelector("product-gallery-navigation"); // adjust selector if it's .class
//   const kgGalleryCarousel = document.querySelector(".product-gallery__carousel");

//   if (!kgNav) return;

//   // Hide all thumbnails first
//   const kgThumbs = kgNav.querySelectorAll("button.product-gallery__thumbnail");
//   const kgCarouselImgs = kgGalleryCarousel.querySelectorAll(".product-gallery__media img");
//   kgThumbs.forEach(el => el.style.display = "none");
//   kgCarouselImgs.forEach(el => el.classList.add("kg-hidden"));

//   // Collect all variant options (skip empty ones)
//   const kgOptions = [kgVariant.option1, kgVariant.option2, kgVariant.option3].filter(Boolean);

//   let kgMatches = 0;

//   // Show thumbnails (the <button>) that contain a matching <img>
//   kgOptions.forEach(kgOpt => {
//     const kgImgs = kgNav.querySelectorAll(`img[alt="${kgOpt}"]`);
//     kgImgs.forEach(img => {
//       const parentBtn = img.closest("button.product-gallery__thumbnail");
//       if (parentBtn) {
//         parentBtn.style.display = "block";
//         kgMatches++;
//       }
//     });

//     const kgCarouselImgs = kgGalleryCarousel.querySelectorAll(`.product-gallery__media img[alt="${kgOpt}"]`);
//     console.log(kgCarouselImgs);
//     kgCarouselImgs.forEach(img => {
//       if (img) {
//         kgCarouselImgs.forEach(el => el.classList.remove("kg-hidden"));
//       }
//     });
//   });

//   // Fallback: if no matches found, show all thumbnails
//   if (kgMatches === 0) {
//     kgThumbs.forEach(el => el.style.display = "block");
//     kgCarouselImgs.forEach(el => el.classList.remove("kg-hidden"));
//   }
// };




window.kgHandleVariantChange = function (kgVariant) {
  const kgNav = document.querySelector("product-gallery-navigation"); // adjust selector if it's .class
  const kgGalleryCarousel = document.querySelector(".product-gallery__carousel");
  const kgCrNavigation = document.querySelector("carousel-navigation");

  if (!kgNav) return;

  // Hide all thumbnails first
  const kgThumbs = kgNav.querySelectorAll("button.product-gallery__thumbnail");
  const kgAllCarouselImgs = kgGalleryCarousel.querySelectorAll(".product-gallery__media img");
  const kgAllCarouselImgWrap = kgGalleryCarousel.querySelectorAll(".product-gallery__media");
  const kgCrNavigationButtons = kgCrNavigation.querySelectorAll("button[data-media-alt]");
  
  kgThumbs.forEach(el => el.style.display = "none");
  kgAllCarouselImgs.forEach(el => el.classList.add("kg-hidden"));
  kgAllCarouselImgWrap.forEach(el => el.style.display = "none");
  kgCrNavigationButtons.forEach(el => el.style.display = "none");

  // Collect all variant options (skip empty ones)
  const kgOptions = [kgVariant.option1, kgVariant.option2, kgVariant.option3].filter(Boolean);

  let kgMatches = 0;

  // Show thumbnails (the <button>) that contain a matching <img>
  kgOptions.forEach(kgOpt => {
    const kgImgs = kgNav.querySelectorAll(`img[alt="${kgOpt}"]`);
    kgImgs.forEach(img => {
      const parentBtn = img.closest("button.product-gallery__thumbnail");
      if (parentBtn) {
        parentBtn.style.display = "block";
        kgMatches++;
      }
    });

    const kgMatchingCarouselImgs = kgGalleryCarousel.querySelectorAll(`.product-gallery__media img[alt="${kgOpt}"]`);
    kgMatchingCarouselImgs.forEach(img => {
      if (img) {
        const kgParentMedia = img.closest(".product-gallery__media");
        if (kgParentMedia) {
          kgParentMedia.style.display = "block"; // show parent
        }
        img.classList.remove("kg-hidden");
      }
    });
    const kgMatchingCrNavButtons = kgCrNavigation.querySelectorAll(`button[data-media-alt="${kgOpt}"]`);
    kgMatchingCrNavButtons.forEach(btn => {
      btn.style.display = "block";
    });
  });

  // Fallback: if no matches found, show all thumbnails
  if (kgMatches === 0) {
    kgThumbs.forEach(el => el.style.display = "block");
    kgAllCarouselImgs.forEach(el => el.classList.remove("kg-hidden"));
    kgAllCarouselImgWrap.forEach(el => el.style.display = "block");
    kgCrNavigationButtons.forEach(el => el.style.display = "block");
  }
};


document.addEventListener('DOMContentLoaded', function () {
  if (typeof window.kgHandleVariantChange === "function") {
    if (window.kgSelectedVariantJson) {
      window.kgHandleVariantChange(window.kgSelectedVariantJson);
    }
  }
});
